import { defineNuxtPlugin, refreshNuxtData, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const options = useRuntimeConfig().public.prismic;
  if (options.preview) {
    window.addEventListener("prismicPreviewUpdate", (event) => {
      event.preventDefault();
      refreshNuxtData();
    });
  }
});
